import Vue from 'vue';

// Minimal Vue app for build process
// Note: This code won't execute because the redirect happens first in index.html
new Vue({
  render: h => h('div')
}).$mount('#app');
